module.exports = __webpack_public_path__ + "static/banner-locevent-final-97fef75fee51990e038e30f0bdd7228f.jpg";